import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import routes from '../routes';
import { getUserRole } from '../../utils/helpers/global';

const AppContent = () => {
  const isLogin = localStorage.getItem('token');
  const routeList = isLogin ? [...routes[getUserRole()], ...routes.Common] : [];
  return (
    <React.Fragment>
      {isLogin && (
        <React.Fragment>
          <Switch>
            {routeList.map((route, index) => {
              return (
                route.component && (
                  <Route
                    key={index}
                    path={route.path}
                    name={route.name}
                    render={(props) => <route.component {...props} />}
                    exact={route.exact}
                  />
                )
              );
            })}
            ,
            <Redirect from="*" to="/notfound" />
          </Switch>
        </React.Fragment>
      )}
      {!isLogin && <Redirect to="/" />}
    </React.Fragment>
  );
};

export default AppContent;
